import React from "react";
import PropTypes from "prop-types";

import ModalApp from "components/ModalApp";
import AddressComponent from "components/AddressComponent";
import {
  editAddresses,
  addAddress,
} from "components/AddressComponent/services/addressService";
import { useUserData } from "hooks/UserContext";
import notify from "components/UI/toast";

export default function AddressUpdateModal({ show, onClose, address, onSaved }) {
  const { user, changeAddress, setUpdateAddresses } = useUserData();

  async function handleConfirm(payload) {
    payload.customerUuid = user.uuid;

    const result = payload.uuid
      ? await editAddresses(user.cpf, payload)
      : await addAddress(user.cpf, payload);

    if (!result?.status) {
      notify(result?.data?.message || "Erro ao atualizar endereço.", "error");
      throw new Error("address-save-failed");
    }

    const updated = { ...address, ...payload, cep: payload.zipCode };
    changeAddress(updated);
    setUpdateAddresses(new Date());
    notify(result?.data?.message || "Endereço atualizado.", "success");

    if (onSaved) onSaved(updated);
  }

  return (
    <ModalApp show={show} handleModal={onClose} contentClassName="modal-address" desktopSize="medium">
      <AddressComponent
        address={address || {}}
        onConfirm={handleConfirm}
        onCancel={onClose}
        highlightMissingFields
      />
    </ModalApp>
  );
}

AddressUpdateModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  address: PropTypes.object,
  onSaved: PropTypes.func,
};
